module.exports = __webpack_public_path__ + "media/images/griale_observa_logo-c76e2ae3492b70f954bf7eacb7a8006b.png";